<table [class.selected]="selected" [class.selectable]="selectable" @fadeInOut>
  <thead>
    <tr>
      <th class="left" [class.hidden-title-background]="!showPeriodTitles" [style.min-width]="'150px'" [style.max-width]="'150px'">{{title}}</th>
      <th class="right" [class.hidden-title]="!showPeriodTitles" *ngFor="let period of periodChunks; let i = index">{{period.name}}</th>
      <th class="right" [class.hidden-title]="!showPeriodTitles">{{languageService.LNG('Label.Total')}}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let line of periodSumLines" [style.background-color]="line.lineColor" [style.color]="line.color">
      <td>{{line.title}}</td>
      <td class="right" *ngFor="let period of periodChunks" [innerText]="getPeriodSum(period, line)"></td>
      <td class="right" [innerText]="getPeriodTotalSum(line)"></td>
    </tr>
  </tbody>
</table>
